import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class MonitorDataService {
    constructor(
        private apiService: ApiService
    ) { }

    // Get a list of all Funds whose status is "active"
    getListOfFundsWithStatusActive(): Promise<Object> {
        const url = 'mrd/common/instruments'
        const query = {};
        query['page'] =  1;
        query['limit'] = 1000;
        return this.apiService.get(url, query);
    }
}